/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/array/ArrayAny.ts
 * @create:      2025-06-26 15:59:16.614
 * @modify:      2025-07-11 21:19:12.792
 * @version:     6.0.0
 * @times:       11
 * @lines:       58
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { TPredicateFunction } from "../type/basic";

/**
 * Determines whether at least one element in the provided array satisfies the given predicate function.
 *
 * @param array - The array to test.
 * @param predicate - A predicate function that takes an element of type `T` and returns a boolean.
 * @returns `true` if at least one element in the array satisfies the predicate; otherwise, `false`.
 * 
 * @since 4.0.0
 * @version 2021-12-14
 */
export function ArrayAny<T>(array: T[], predicate: TPredicateFunction<T>): boolean{
    // for (const item of array) {
    //     if (func(item)) {
    //         return true;
    //     }
    // }

    if (array.length > 0) {
        return array.some(p => predicate(p));
    }

    return false;
}
